import React from 'react';

import { CreateButton } from '@atlassian/navigation-system';
import { CommonActions, Search } from '@atlassian/navigation-system/top-nav-items';

import { MockTopBar } from './common/mock-top-bar';

export const CommonActionsLayoutExample = () => {
	return (
		<MockTopBar>
			<CommonActions>
				<Search label="Search" />
				<CreateButton>Create</CreateButton>
			</CommonActions>
		</MockTopBar>
	);
};
